export const texts = {
  search: {
    de: 'Suchen',
    en: 'Search'
  }
};
